export const RECEIVE_AUTH = "RECEIVE_AUTH";
export const IS_LOGIN = "IS_LOGIN";
export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";
export const RECEIVE_PAGE_HOME = "RECEIVE_PAGE_HOME";
export const RECEIVE_PAGE_ABOUT = "RECEIVE_PAGE_ABOUT";
export const RECEIVE_PAGE_SERVICE = "RECEIVE_PAGE_SERVICE";
export const RECEIVE_PAGE_CONTACT = "RECEIVE_PAGE_CONTACT";
export const RECEIVE_BRANDS = "RECEIVE_BRANDS";
export const RECEIVE_CATEGORIES = "RECEIVE_CATEGORIES";
export const RECEIVE_PRODUCTS = "RECEIVE_PRODUCTS";
export const RECEIVE_PRODUCTS_RECENTLY_VIEW = "RECEIVE_PRODUCTS_RECENTLY_VIEW";
export const ADD_PRODUCTS_RECENTLY_VIEW = "ADD_PRODUCTS_RECENTLY_VIEW";
export const RECEIVE_WISHLIST = "RECEIVE_WISHLIST";
export const ADD_WISHLIST = "ADD_WISHLIST";
export const REMOVE_WISHLIST = "REMOVE_WISHLIST";
export const CLEAR_WISHLIST = "CLEAR_WISHLIST";
export const RECEIVE_FAQS = "RECEIVE_FAQS";
export const RECEIVE_POST_CATEGORIES = "RECEIVE_POST_CATEGORIES";
export const RECEIVE_POSTS = "RECEIVE_POSTS";
export const FETCHING_BRANDS = "FETCHING_BRANDS";
export const FETCHING_CATEGORIES = "FETCHING_CATEGORIES";
export const FETCHING_PRODUCTS = "FETCHING_PRODUCTS";
export const RECEIVE_LANGUAGES = "RECEIVE_LANGUAGES";



// WEBPACK FOOTER //
// ./src/actions/actionType.js